<div class="my-5">
  <sm-page-header [breadcrumb]="breadcrumb" title="agpm.history.title" [description]="('agpm.history.description' | translate) + ' : ' + (data.length > 0 ? data[0].ref : '')"> </sm-page-header>

  <div class="content">
      <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data" [loading]="loading"></sm-data-table-builder>
  </div>
